jQuery(function($) {

///// Nav Icon /////
// On Open //
$(document).on("opened.zf.offcanvas", function(ev){
	if($('#offCanvasNestedOverlap').hasClass('is-open')) {
        $('.nav-icon-wrapper').addClass('open');
        $('#nav-icon1').addClass('open');
    }
});
// Make sure the other off canvas closes on click //
$(document).ready(function(){
	$('#nav-icon1').click(function(){
		$('#offCanvasNestedOverlap-Contact').removeClass('is-open');
	});
});
// On Close //
$(document).on("closed.zf.offcanvas", function(ev){
    $('.nav-icon-wrapper').removeClass('open');
    $('#nav-icon1').removeClass('open');
});

///// Nav Contact Form /////
// Make sure the other off canvas closes on click //
$(document).ready(function(){
	$('.header-contact').click(function(){
		$('#offCanvasNestedOverlap').removeClass('is-open');
		$('.nav-icon-wrapper').removeClass('open');
		$('#nav-icon1').removeClass('open');
	});
});
// Custom form dropdown craziness //
$(document).ready(function(){
	$('.form-drop-down').click(function(){
		$('.gfield_radio').toggleClass('active');
	});
	$('.gfield_radio li label').click(function(){
		$('.gfield_radio').removeClass('active');
	});
	// Change the label based on selection //
	$('input[type=radio]').change(function(evt) {
	    $('#field_1_7 .gfield_label').html($(this).val());
	});
});

// Fade in side-bar menu //
jQuery(window).load(function(){
	//jQuery(".loading").fadeOut("slow");
	jQuery("#indicator-sidebar .accordion-menu").fadeIn("slow");
});

// Open correlated drop menu on scroll with Magellan //
if ($('.main-anchor').hasClass('is-active')) {
	$('.main-anchor.is-active').trigger('click');
}

// Close Filter Menu on Choice //
$(document).ready(function(){
	$('.dropdown-pane ul li').click(function(){
		$('.dropdown-pane').removeClass('is-open');
	});
});


});


